.container {
  flex: 1;
  padding: 0 2.4rem 2.4rem;
  height: 100%;
}
